import React from 'react';

import { AuthProvider } from 'contexts/AuthContext';

import TraceRoute from 'routes/TraceRoute';
import { UserSession, getUserSession } from 'stores/AuthenticationStoreAdapter';
import { ListFinancialYearResponse, listFinancialYear } from 'stores/FinancialYearStoreAdapter';
import { ManagerResult, listManager } from 'stores/ProjectStoreAdapter';
import { UserResult, getUser } from 'stores/UserStoreAdapter';

/**
 * 認証ルート。
 * - getUserSession で認証を確認し、未認証時は /login にリダイレクト
 * - getUser / listFinancialYear / listManager を並行取得
 * - AuthProvider で全子コンポーネントに userSession / users / managers / backOfficeUsers / financialYearData を提供
 */
const AuthenticatedRoute: React.FC = () => {
  const [userSession, setUserSession] = React.useState<UserSession | null>(null);
  const [users, setUsers] = React.useState<UserResult[]>([]);
  const [managers, setManagers] = React.useState<ManagerResult[]>([]);
  const [financialYearData, setFinancialYearData] = React.useState<ListFinancialYearResponse>({
    results: [],
    current: null,
  });
  const [checked, setChecked] = React.useState(false);

  React.useEffect(() => {
    getUserSession()
      .then((session) => {
        if (session) {
          setUserSession(session);
          return Promise.all([
            getUser({}).then((userList) => {
              setUsers(userList);
            }),
            listFinancialYear().then((res) => {
              setFinancialYearData(res);
            }),
            listManager().then((managerList) => {
              setManagers(managerList);
            }),
          ]);
        } else {
          document.location = '/login';
        }
      })
      .catch(() => {
        document.location = '/login';
      })
      .finally(() => {
        setChecked(true);
      });
  }, []);

  if (!checked || !userSession) {
    return <></>;
  }

  // BACK_OFFICE ロールを持つユーザーを抽出
  const backOfficeUsers = users.filter((u) => u.roles.includes('BACK_OFFICE'));

  return (
    <AuthProvider value={{ userSession, users, managers, backOfficeUsers, financialYearData }}>
      <TraceRoute />
    </AuthProvider>
  );
};

export default AuthenticatedRoute;
